/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Build_Guided_DescInputs */

const en_mk_build_guided_desc = /** @type {(inputs: Mk_Build_Guided_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Need a second opinion? Get a review, polishing, or a working session to move forward.`)
};

const id_mk_build_guided_desc = /** @type {(inputs: Mk_Build_Guided_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Butuh pendapat kedua? Minta tinjauan, perapian, atau sesi bersama untuk melanjutkan pekerjaan.`)
};

/**
* | output |
* | --- |
* | "Need a second opinion? Get a review, polishing, or a working session to move forward." |
*
* @param {Mk_Build_Guided_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_build_guided_desc = /** @type {((inputs?: Mk_Build_Guided_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Build_Guided_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_build_guided_desc(inputs)
	return en_mk_build_guided_desc(inputs)
});